
import { Navigation, Globe2, Sparkles } from "lucide-react"
import type { TravelType } from "./Filter"

interface DHeroProps {
  travelType?: TravelType;
  searchQuery?: string;
  filteredCount?: number;
}



const getHeroImageByTravelType = (type: TravelType): string => {
  const images: Record<TravelType, string> = {
    all: "https://images.unsplash.com/photo-1433838552652-f9a46b332c40?q=80&w=2070&auto=format&fit=crop",
    international: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2121&auto=format&fit=crop", // beautiful scenic landscape
    domestic: "https://images.unsplash.com/photo-1611348524140-53c9a25263d6?q=80&w=2070&auto=format&fit=crop", // El Nido, Palawan - crystal clear lagoons
    cruise: "https://images.unsplash.com/photo-1605969072412-d83007fc9f47?q=80&w=2070&auto=format&fit=crop", // luxury cruise ship at sea
  }
  return images[type]
}

const DHero = ({ travelType = "all", searchQuery, filteredCount }: DHeroProps) => {
  return (
    <section className="relative h-[500px] sm:h-[550px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${getHeroImageByTravelType(travelType)}')`,
          backgroundAttachment: 'fixed',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      
      <div className="relative text-center text-balance px-4 z-10 max-w-5xl mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md rounded-full px-5 py-2.5 mb-6 border border-white/30 animate-in fade-in duration-700">
          <Sparkles className="w-4 h-4 text-orange-400" />
          <span className="text-sm font-semibold text-white tracking-wide">Handpicked Destinations</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl animate-in slide-in-from-bottom duration-700" style={{ animationDelay: '200ms' }}>
          {searchQuery ? (
            <>Search Results for <span className="text-orange-500 drop-shadow-lg">"{searchQuery}"</span></>
          ) : (
            <>Explore Your Next <span className="text-orange-500 drop-shadow-lg">Adventure</span></>
          )}
        </h1>
        
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 max-w-3xl mx-auto drop-shadow-lg leading-relaxed animate-in slide-in-from-bottom duration-700" style={{ animationDelay: '400ms' }}>
          {searchQuery ? (
            filteredCount !== undefined ? `Found ${filteredCount} packages matching your search` : "Searching for your perfect travel experience..."
          ) : (
            "Discover amazing destinations and create unforgettable memories with our curated travel packages"
          )}
        </p>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 animate-in fade-in duration-700" style={{ animationDelay: '600ms' }}>
          <div className="flex items-center gap-2 text-white/95">
            <Globe2 className="w-5 h-5 text-orange-400" />
            <span className="text-sm sm:text-base font-semibold">50+ Destinations</span>
          </div>
          <div className="w-1 h-6 bg-white/30 hidden sm:block"></div>
          <div className="flex items-center gap-2 text-white/95">
            <Navigation className="w-5 h-5 text-orange-400" />
            <span className="text-sm sm:text-base font-semibold">4 Regions Covered</span>
          </div>
        </div>
      </div>
      
      <div id="data-scroll-section" data-scroll-section></div>
    </section>
  )
}

export default DHero
